module.exports = __webpack_public_path__ + "assets/elsa-dashboard-logo.649e4ecc.svg";